import React from "react";
import { Cross } from "../ExpandClose";
import { DisplayFlexCenter, IconWrap, PopContainer, PopContainerWrap, PopupContentContainer, PopupContentLine1, PopupContentLine1Align, PopupHeading, PopupWrap, PrimaryButton, Underlinelink } from "./styles";

class Popup extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "hidden";
  }
 componentWillUnmount() {
    document.body.style.overflow = "";
  }
  render() {
    return (
      <PopContainerWrap>
        <PopupWrap mheight={this.props.mheight} mwidth={this.props.mwidth} height={this.props.height} width={this.props.width}>
          <PopContainer>
            <IconWrap onClick={this.props.closeModal}>
              <Cross />
            </IconWrap>
            <PopupHeading>{this.props.content.heading}</PopupHeading>
            <PopupContentContainer>
              {this.props.content.type === "reset" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1>
                    {this.props.content.line1}
                  </PopupContentLine1>
                </DisplayFlexCenter>
              ) : this.props.content.type === "exit" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="88%" paddingBottom="30px">
                    {this.props.content.line1}
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              ) : this.props.content.type === "removeInfo" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="88%" paddingBottom="30px">
                    {this.props.content.line1}
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              ) :
              this.props.content.type === "remove" ? (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="309px" paddingBottom="30px">
                    {this.props.content.line1}
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              ) : (
                <DisplayFlexCenter>
                  <PopupContentLine1Align width="485px !important" paddingBottom="10px">
                    {this.props.content.line1}
                  </PopupContentLine1Align>
                </DisplayFlexCenter>
              )}
             <div>{this.props.content.line2}</div>
            </PopupContentContainer>
           <DisplayFlexCenter>
              {
                /* INVITE INTRESTED PARTIES */
                this.props.content.type === "invite" ?  (
                  <PrimaryButton onClick={this.props.handleInviteBack}>
                  BACK TO HOME
                  </PrimaryButton>) :
               this.props.content.type === "autofill" ? 
                <PrimaryButton onClick={this.props.handleContinue}>
                    continue
                  </PrimaryButton> :
                this.props.content.type === "reset" ? (
                  this.props.advisorType === "Primary"  || this.props.advisorType === "legacy"  ? (
                    <PrimaryButton onClick={this.props.handleReset}>
                      continue
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton onClick={this.props.handleResetSecondary}>
                      {this.props.content.continue}
                    </PrimaryButton>
                  )
                ) : this.props.content.type === "exit" ? (
                  <PrimaryButton onClick={this.props.handleExitClick}>
                      {this.props.content.continue}
                    </PrimaryButton>
                ) : (
                  <PrimaryButton onClick={this.props.handleRemove}>
                    {this.props.content.continue}
                  </PrimaryButton>
                )
              }
            </DisplayFlexCenter>
            <Underlinelink onClick={this.props.closeModal}>
              {this.props.content.cancel}
            </Underlinelink>
          </PopContainer>
        </PopupWrap>
      </PopContainerWrap>
    );
  }
}

export default Popup;
